import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'upsc-cod',
  templateUrl: './cod.component.html',
  styleUrls: ['./cod.component.scss']
})
export class CodComponent implements OnInit {

  ngOnInit(): void {
  }
}
